"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module("models").service("CustomListsService", ["ApiService", "$rootScope", function (ApiService, $rootScope) {
  var _this = this;

  var that = this;

  that.listsCache = [];

  that.debug = debug("services:customListsService");

  var params = {
    name: "customLists",
    attributesForCache: ["name"],
    formatName: function formatName(element) {
      return element.name ? element.name : "???";
    },
    defaultOrder: { name: 1 }
  };

  angular.extend(that, ApiService.getModelBis(params));

  that.getSelectArray = function (nameList) {
    return new Promise(function (resolve, reject) {
      if (that.listsCache[nameList]) {
        resolve(that.listsCache[nameList]);
      } else {
        that.customGet("" + nameList).then(function (customList) {
          var array = [];

          for (var index = 0; index < customList.items.length; index++) {
            var response = customList.items[index];

            array.push({
              name: response.name,
              value: response.value,
              data: response.data
            });
          }

          if (!that.cache) {
            that.cache = {};
          }

          // Role filtering according to customer
          if (nameList === "roles" && $rootScope.$selectedCustomerId !== "$592e962acef2545fb62f1a99") {
            array = array.filter(function (item) {
              return ["driver", "user", "hr", "user-admin"].includes(item.value);
            });
          } else if (nameList === "roles" && $rootScope.$selectedCustomerId === "$592e962acef2545fb62f1a99") {
            array = array.filter(function (item) {
              return ["super-admin", "super-operator", "operator"].includes(item.value);
            });
          }

          that.listsCache[nameList] = array;

          resolve(array);
        });
      }
    });
  };

  that.getNameByValue = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(nameList, value) {
      var array, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              that.debug("try to getNameByValue", nameList, value);

              array = void 0;

              if (!(!that.cache || !that.cache[nameList])) {
                _context.next = 10;
                break;
              }

              that.debug("la liste n est pas chargée");
              _context.next = 7;
              return that.getSelectArray(nameList);

            case 7:
              array = _context.sent;
              _context.next = 12;
              break;

            case 10:
              that.debug("la liste est deja chargée");
              array = that.cache[nameList];

            case 12:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 15;
              _iterator = array[Symbol.iterator]();

            case 17:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 24;
                break;
              }

              item = _step.value;

              if (!(item.value === value)) {
                _context.next = 21;
                break;
              }

              return _context.abrupt("return", item.name);

            case 21:
              _iteratorNormalCompletion = true;
              _context.next = 17;
              break;

            case 24:
              _context.next = 30;
              break;

            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](15);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 30:
              _context.prev = 30;
              _context.prev = 31;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 33:
              _context.prev = 33;

              if (!_didIteratorError) {
                _context.next = 36;
                break;
              }

              throw _iteratorError;

            case 36:
              return _context.finish(33);

            case 37:
              return _context.finish(30);

            case 38:
              return _context.abrupt("return", "?-?");

            case 41:
              _context.prev = 41;
              _context.t1 = _context["catch"](0);
              return _context.abrupt("return", "*?*");

            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 41], [15, 26, 30, 38], [31,, 33, 37]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}]);